import axios from 'axios'
import { emailLogin, facebookLogin } from '@/calls/login';
import { ApiFatalError, ApiInvalidParamError } from '@/errors/errors';
import { dateToStr, modifyDate, setTimeoutToDate } from '@/helpers/helpers';
import { refreshToken } from '@/calls/refreshToken';
import router from '@/router';
import {
  LOCAL_STORAGE_ACCESS_TOKEN_EXPIRATION_KEY,
  LOCAL_STORAGE_ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS
} from '@/helpers/constants';
import FacebookAPI from '@/helpers/FacebookAPI';
import { logout } from '@/calls/logout';

const login = {
  namespaced: true,
  state: {
    requests: 0,
    form: null,
    logged: false,
    error: false,
    errorFb: false,
    badParams: false,
    formError: null,
    redirectTo: 'Home',
    refreshTokenTimer: undefined,
    fields: {
      email: '',
      password: ''
    }
  },
  mutations: {
    setForm(state, el) {
      state.form = el;
    },
    updateField(state, { type, value }) {
      state.fields[type] = value;
    },
    updateRedirect(state, route) {
      state.redirectTo = route;
    },
    setLogged(state, logged) {
      if (!logged) {
        localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
        localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_EXPIRATION_KEY);
      }
      state.logged = logged;
    },
    setError(state, flag) {
      state.error = flag;
    },
    setErrorFb(state, flag) {
      state.errorFb = flag;
    },
    setBadParams(state, flag) {
      state.badParams = flag;
    },
    setFormError(state, flag) {
      state.formError = flag;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    }
  },
  actions: {
    /**
     * @param commit
     * @param dispatch
     * @param state
     * @param loginResponse sometimes we don't need to make an API call, like just after registration ( because registration already log-in user )
     * @returns {Promise<void>}
     */
    async facebookLogin({ commit, dispatch, state }, { loginResponse } = { loginResponse: undefined }) {
      commit('increaseRequests');
      commit('setError', false);
      const fbLoginStatus = loginResponse ? 'connected' : (await FacebookAPI.login()).status;

      if (fbLoginStatus === 'connected') {
        const formData = new FormData();
        if (!loginResponse) {
          const user = await FacebookAPI.me();
          console.log('user facebook', user.email, user.id);
          formData.append('email', user.email);
          formData.append('id', user.id.toString());
        }
        try {
          if (!loginResponse) {
            loginResponse = await facebookLogin(formData);
          }
          commit('setError', false);
          commit('setBadParams', false);
          commit('setFormError', null);
          console.log('facebook login response', loginResponse);
          dispatch('storeToken', {
            accessToken: loginResponse.access_token,
            accessTokenExpiration: loginResponse.access_token_expiration
          });
          
          commit('setLogged', true);

          // Redirect to first QR code (chapter or story), or to Home
          const firstPage = localStorage.getItem('firstPage');
          const firstPageType = localStorage.getItem('firstPageType');
          const lang = localStorage.getItem('lang') || 'ko';
          if (firstPage) {
            if (firstPageType === 'Chapter') {
              router.push({ name: firstPageType, params: { locale: lang, chapterId: firstPage } });
            } else {
              router.push({ name: firstPageType, params: { locale: lang, storyId: firstPage } });
            }
            localStorage.removeItem('firstPage');
            localStorage.removeItem('firstPageType');
          } else {
            router.push({ name: state.redirectTo });
          }
          document.body.classList.remove('has-open-modal');
        } catch (e) {

          console.log('destrooooyyyy', "facebookLogin")
          dispatch('destroyToken');
          commit('setLogged', false);
          if (e instanceof ApiInvalidParamError) {
            commit('setBadParams', true);
            commit('setErrorFb', true);
            commit('setFormError', e.response.message);
          } else if (e instanceof ApiFatalError) {
            console.error('Login fatal error', e.response);
            commit('setErrorFb', true);
            commit('setFormError', e.response.message);
          } else {
            console.error('Login other fatal error', e.message);
            commit('setErrorFb', true);
            commit('setFormError', e.message);
          }
        }
        commit('decreaseRequests');
      }
    },
    /**
     * @param state
     * @param commit
     * @param dispatch
     * @param loginResponse sometimes we don't need to make an API call, like just after registration ( because registration already log-in user )
     * @returns {Promise<void>}
     */
    async emailLogin({ state, commit, dispatch }, { loginResponse } = { loginResponse: undefined }) {
      console.log('loginResponse', loginResponse);
      commit('increaseRequests');
      commit('setError', false);
      try {
        if (!loginResponse) {
          loginResponse = await emailLogin();
        }
        commit('setError', false);
        commit('setBadParams', false);
        commit('setFormError', null);
        console.log('email login response', loginResponse);
        dispatch('storeToken', { accessToken: loginResponse.access_token, accessTokenExpiration: loginResponse.access_token_expiration });
        console.log('state', loginResponse);
        commit('setLogged', true);
        axios.defaults.headers.common = {
          Authorization: `Bearer ${loginResponse.access_token}`
        };
        // Redirect to first QR code (chapter or story), or to Home
        const firstPage = localStorage.getItem('firstPage');
        const firstPageType = localStorage.getItem('firstPageType');
        const lang = localStorage.getItem('lang') || 'ko';
        if (firstPage) {
          if (firstPageType === 'Chapter') {
            router.push({ name: firstPageType, params: { locale: lang, chapterId: firstPage } });
          } else {
            router.push({ name: firstPageType, params: { locale: lang, storyId: firstPage } });
          }
          localStorage.removeItem('firstPage');
          localStorage.removeItem('firstPageType');
        } else {
          router.push({ name: state.redirectTo });
        }
        document.body.classList.remove('has-open-modal');
      } catch (e) {
        console.log('emailLogin', 'destrooooyyyy')
        dispatch('destroyToken');
        commit('setLogged', false);
        if (e instanceof ApiInvalidParamError) {
          commit('setBadParams', true);
          commit('setError', true);
          commit('setFormError', e.response.message);
        } else if (e instanceof ApiFatalError) {
          console.log(e.response);
          console.error('Login fatal error', e.response);
          commit('setError', true);
          commit('setFormError', e.response.message);
        } else {
          console.error('Login other fatal error', e.message);
          commit('setError', true);
          commit('setFormError', e.message);
        }
      }
      commit('decreaseRequests');
    },
    logout({ dispatch, commit }) {
      // backend logout
      logout();
      console.log('logout', 'destrooooyyyy')
      dispatch('destroyToken');
      commit('setLogged', false);
      router.push({ name: 'Login' });
      document.body.classList.remove('has-open-modal');
    },
    // eslint-disable-next-line
    storeToken({ commit, state, dispatch }, { accessToken, accessTokenExpiration }) {
      localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY, accessToken);
      localStorage.setItem(LOCAL_STORAGE_ACCESS_TOKEN_EXPIRATION_KEY, accessTokenExpiration);
      dispatch('initRefreshTokenTimer');
    },
    // eslint-disable-next-line
    isLogged() {
      return localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    },
    destroyToken() {
      localStorage.removeItem(LOCAL_STORAGE_ACCESS_TOKEN_KEY);
    },
    async refreshToken({ commit, dispatch }) {
      try {
        const response = await refreshToken();
        dispatch('storeToken', { accessToken: response.access_token, accessTokenExpiration: response.access_token_expiration });
      } catch (e) {
        // TODO: should logout
        commit('setLogged', false);
        console.error('Refresh token fatal error', e.message);
      }
    },
    async initRefreshTokenTimer({ dispatch, state }) {
      if (state.refreshTokenTimer) {
        clearTimeout(state.refreshTokenTimer);
      }
      const expireAtInSeconds = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN_EXPIRATION_KEY);
      let expireAt = new Date(expireAtInSeconds * 1000);
      console.log('Token will expirate at:', dateToStr(expireAt));
      console.log(`Will refresh: ${REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS}s before`);
      expireAt = modifyDate(expireAt, { seconds: -REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS });
      console.log('Token will be refreshed at:', dateToStr(expireAt), 'now:', dateToStr(new Date()));
      state.refreshTokenTimer = setTimeoutToDate(async () => {
        console.log('Should refresh token now !');
        await dispatch('refreshToken');
      }, expireAt);
    },
  }
};

export default login;
